<template>
  <div
    @click="() => (detailsModal = true)"
    class="rounded-lg bg-white p-5 mt-5 shadow-md relative cursor-pointer"
  >
    <spinner :loading="removeMemberLoader" />
    <!-- <div v-if="!memberData.userName" class="text-gray-500">
      Empty segment
    </div> -->
    <DeleteModal
        title="Remove Confirmation"
        message="Are you sure you want to remove Member?"
        :callback="deleteConfirmed"
        :openModal="deleteModal"
        :handlePopups="
          e => {
            e.stopPropagation();
            return (deleteModal = false);
          }
        "
      />
    <div v-if="detailsModal">
      <MemberDetailsModal
      :openModal="detailsModal"
      :closeModalCallback="
        e => {
          e.stopPropagation();
          return (detailsModal = false);
        }
      "
      :memberData="memberData"
      :removeMemberLoader="removeMemberLoader"
      :handleDeleteModal="(e)=>{
         e.stopPropagation();
         detailsModal = false;
        return deleteModal = true;
      }"
      :courseId="courseId"
    />
    </div>
    <!-- <div
      @click="() => (deleteModal = true)"
      class="absolute top-0 right-0 mr-2 mt-2"
    >
      <closeIcon />
    </div> -->

    <h5 class="mb-0 text-black flex"> <div v-if="isReminderDone"> <clock/> </div> {{ memberData.userName }}</h5>
  </div>
</template>

<script>
import DeleteModal from '@/components/Common/DeleteModal.vue';
import MemberDetailsModal from '@/components/pipeline/MemberDetailsModal.vue';
import spinner from '@/components/spinner.vue';
import Clock from '../icons/clock.vue';

export default {
  name: 'MemberProfileCard',
  props: ['memberData', 'courseId'],
  components: {
    spinner,
    MemberDetailsModal,
    DeleteModal,
    Clock,
  },
  data() {
    return {
      deleteModal: false,
      removeMemberLoader: false,
      detailsModal: false,
    };
  },
  computed: {
    isReminderDone() {
      const currentTime = new Date(Date.now()).getTime();
      const reminderTime = new Date(this.memberData?.reminder?.reminderTime).getTime();
      return reminderTime < currentTime;
    },
  },
  methods: {
    async deleteConfirmed(e) {
      try {
        e.stopPropagation();
        this.deleteModal = false;
        this.removeMemberLoader = true;
        const res = await this.$store.dispatch('removeMemberFromCourse', {
          studentType: 'enrolled',
          studentId: [this.memberData._id],
          courseId: this.courseId,
          removesubmissions: true,
        });
        console.log(res);
        await this.$store.dispatch('getPipelineDetails');
        this.removeMemberLoader = false;
      } catch (error) {
        console.log({ error });
        this.deleteModal = false;
        this.removeMemberLoader = false;
      }
    },
  },
};
</script>
